const MOBILE_BREAKPOINT = 739;

const getChannel = secondLevelDomain =>
  window.innerWidth <= MOBILE_BREAKPOINT &&
  secondLevelDomain.includes('xing.com')
    ? 'webm'
    : 'web';

export default getChannel;
